import { Component, Input, OnInit } from '@angular/core';
import { HomeConfig } from 'src/app/model/homeConfig';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.css'],
})
export class CatalogueComponent implements OnInit {
  @Input() config!: HomeConfig;
  imageUrl = environment.apiUrl;
  responsiveOptions: any;
  lang = (localStorage.getItem('lang') || 'en').toLowerCase();
  isArabic: boolean = false;

  ngOnInit() {
    this.isArabic = this.lang === 'ar';
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
      },
    ];
  }
}
